/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Agent_Triggers_Limit_ReachedInputs */



/**
* | output |
* | --- |
* | "Your organization allows at most {max} schedules and events per agent." |
*
* @param {Agent_Triggers_Limit_ReachedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_triggers_limit_reached = /** @type {((inputs: Agent_Triggers_Limit_ReachedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Triggers_Limit_ReachedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ihre Organisation erlaubt höchstens ${i?.max} Auslöser pro Agent.`)
	return /** @type {LocalizedString} */ (`Your organization allows at most ${i?.max} schedules and events per agent.`)
});